const logStyles = {
    default: ['color: #EEE', 'color: #BBB'],
    highlighted: ['color: #EEE', 'color: #BBB', 'color: #FFF', 'color: #BBB'],
};

export function log(turn: number, type: string, message: string) {
    const parsed = message.replace(/'(.+?)'/g, '%c$1%c');
    const styles = message.match(/'(.+?)'/g) ? logStyles.highlighted : logStyles.default;
    console.log(`%c[${turn}:${type}] %c${parsed}`, ...styles);
}